var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--xl footer-info"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('u-txt-default', {
      staticClass: "txt--sm white--text mb-2 mb-md-4"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('ul', {
      staticClass: "footer-info__list"
    }, _vm._l(item.items, function (item, index) {
      return _c('li', {
        key: index
      }, [_c('u-txt-default', {
        staticClass: "txt--sm grey--text text--lighten-3"
      }, [_vm._v(" " + _vm._s(item.title) + " "), _c('span', {
        staticClass: "grey--text text--lighten-2"
      }, [_vm._v(_vm._s(item.text))])])], 1);
    }), 0)], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }